import { createFeature, createReducer, on } from '@ngrx/store';
import { JobTypeServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedJobTypeActions } from './paginated-job-type.actions';

export const paginatedJobTypeFeatureKey = 'paginatedJobType';

export interface PaginatedJobTypeState {
  items: JobTypeServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
}

export const initialState: PaginatedJobTypeState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedJobTypeActions.listPaginatedJobTypes,
    (state): PaginatedJobTypeState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedJobTypeActions.listPaginatedJobTypesSuccess,
    (state, { data }): PaginatedJobTypeState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedJobTypeActions.listPaginatedJobTypesFailure,
    (state, { error }): PaginatedJobTypeState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);

export const paginatedJobTypeFeature = createFeature({
  name: paginatedJobTypeFeatureKey,
  reducer,
});
